/** Small inline icons (lucide shapes), so the site has no icon-library dependency. */
const base = { fill: "none", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" } as const;

export const IconFlask = ({ className = "" }) => (
  <svg viewBox="0 0 24 24" className={className} aria-hidden {...base}>
    <path d="M10 2v7.5L4.5 19a2 2 0 0 0 1.7 3h11.6a2 2 0 0 0 1.7-3L14 9.5V2M8.5 2h7M7 16h10" />
  </svg>
);
export const IconBook = ({ className = "" }) => (
  <svg viewBox="0 0 24 24" className={className} aria-hidden {...base}>
    <path d="M8 3H2v15h7a3 3 0 0 1 3 3V7a4 4 0 0 0-4-4zM16 3h6v15h-7a3 3 0 0 0-3 3V7a4 4 0 0 1 4-4z" />
  </svg>
);
export const IconRefresh = ({ className = "" }) => (
  <svg viewBox="0 0 24 24" className={className} aria-hidden {...base}>
    <path d="M3 12a9 9 0 0 1 15-6.7L21 8M21 3v5h-5M21 12a9 9 0 0 1-15 6.7L3 16M3 21v-5h5" />
  </svg>
);
export const IconCheck = ({ className = "" }) => (
  <svg viewBox="0 0 24 24" className={className} aria-hidden {...base}>
    <path d="M20 6 9 17l-5-5" />
  </svg>
);
export const IconGift = ({ className = "" }) => (
  <svg viewBox="0 0 24 24" className={className} aria-hidden {...base}>
    <path d="M20 12v10H4V12M2 7h20v5H2zM12 22V7M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7zM12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z" />
  </svg>
);
